import { Link } from 'react-router-dom';

type Props = {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: Props) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-6 md:mb-8">
      <div className="max-w-2xl">
        {eyebrow && (
          <div className="flex items-center gap-2 mb-2.5">
            <span className="w-6 h-px bg-accent-500"></span>
            <span className="text-[11px] tracking-[0.24em] uppercase text-accent-600 font-label">
              {eyebrow}
            </span>
          </div>
        )}
        <h2 className="text-xl md:text-2xl font-semibold tracking-wide">{title}</h2>
        {description && (
          <p className="mt-2 text-sm text-secondary-600 leading-6">{description}</p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="group inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer self-start md:self-auto"
        >
          {actionLabel}
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform"></i>
        </Link>
      )}
    </div>
  );
}